<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Ad Period</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="saveAdPeriod" v-if="adPeriodCopy">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">From</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <FlatPickr
                    v-model="adPeriodCopy.startTimestamp"
                    :config="dateConfig"
                    class="input"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">To</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <FlatPickr
                    v-model="adPeriodCopy.endTimestamp"
                    :config="dateConfig"
                    class="input"
                  />
                </div>
              </div>
            </div>
          </div>

          <input type="submit" style="display: none" />
        </form>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="saveError">
          {{ saveError }}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button class="button" @click="cancel" :disabled="isSaving">
              Cancel
            </button>
            <button
              class="button is-primary"
              @click="saveAdPeriod"
              :class="{ 'is-loading': isSaving }"
              :disabled="isSaving"
            >
              Save
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import { SAVE_AD_PERIOD } from '@/modules/ads/adsStore'

export default {
  name: 'AdEditPeriodModal',

  components: { FlatPickr },

  props: {
    adsStorePath: {
      type: String,
      required: true
    },

    adPeriod: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      adPeriodCopy: null,
      isSaving: false,
      saveError: null
    }
  },

  mounted() {
    this.adPeriodCopy = JSON.parse(JSON.stringify(this.adPeriod))
  },

  computed: {
    dateConfig() {
      return {
        enableTime: true,
        enableSeconds: false,
        time_24hr: true,
        dateFormat: 'Y-m-d H:i',
        locale: {
          firstDayOfWeek: 1
        }
      }
    }
  },

  methods: {
    cancel() {
      this.$emit('cancelled')
    },

    async saveAdPeriod() {
      if (this.adPeriodCopy.startTimestamp > this.adPeriodCopy.endTimestamp) {
        this.saveError = 'From cannot be later than To'
        return
      }

      this.saveError = null
      this.isSaving = true

      try {
        const saveAdPeriodAction = `${this.adsStorePath}/${SAVE_AD_PERIOD}`
        await this.$store.dispatch(saveAdPeriodAction, {
          adPeriod: this.adPeriodCopy
        })

        this.$emit('succeeded')
      } catch (error) {
        this.saveError = error || 'Something went wrong.'
      } finally {
        this.isSaving = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card-head {
  border-bottom: 0;
}

.modal-card-foot {
  border-top: 0;
}

.notification {
  margin-top: 1em;
}
</style>
